import { useNavigate } from "react-router-dom";
import { useLang } from "../../contexts/LangContext";
import { useLogSession } from "../../contexts/LogSessionContext";
import { v4 as uuidv4 } from "uuid";

export default function AddAnotherFishItem() {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const { newFishItem, setNewFishItem, currentMealRecord } = useLogSession();

  const handleSameFish = () => {
    // Create a new fish item with the same fish details
    if (!newFishItem) {
      // Fallback to which-fish if no current item
      navigate("../which-fish");
      return;
    }

    setNewFishItem({
      id: uuidv4(),
      fish_id: newFishItem.fish_id,
      fish_name: newFishItem.fish_name,
      fish_english_name: newFishItem.fish_english_name,
      fish_local_name: newFishItem.fish_local_name,
      recipe: "unknown",
      portion_type: "portion",
      piece_type: undefined,
      number_of_portions: 1,
      weight_per_portion: 0,
      estimated_weight: 0,
      weight_unit: "gm",
      consumed_soft_bone: false,
      ingredients: "",
    });
    navigate("../which-recipe");
  };

  const handleDifferentFish = () => {
    // Start adding a different fish item
    navigate("../which-fish");
  };

  const handleNo = () => {
    // Proceed to review the full meal
    navigate("../review-log");
  };

  // Get the display name for the current fish
  const currentFishName = newFishItem
    ? lang === "bn"
      ? newFishItem.fish_local_name || newFishItem.fish_name
      : newFishItem.fish_english_name || newFishItem.fish_name
    : "";

  return (
    <div className="w-full grow flex flex-col items-center justify-start gap-10 text-center px-scr pt-12">
      <h1 className="text-3xl font-bold text-rose-700">
        {t("addAnotherFishItem_Heading")}
      </h1>

      <div className="flex flex-col gap-4 w-full max-w-sm">
        {/* Option 1: Add same fish */}
        {newFishItem && (
          <button
            type="button"
            onClick={handleSameFish}
            className="w-full flex flex-row items-center justify-center gap-2 button-base button-bg-grad-green py-4"
          >
             <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="size-6"
                style= {{ minWidth: "24px" }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m4.5 12.75 6 6 9-13.5"
                />
              </svg>
              <span className="font-bold">{t("addAnotherFishItem_SameFish")} &nbsp;<span className="text-sm opacity-90">({currentFishName})</span></span>       
          </button>
        )}

        {/* Option 2: Add different fish */}
        <button
          type="button"
          onClick={handleDifferentFish}
          className="w-full flex flex-row items-center justify-center gap-3 button-base button-bg-grad-light-blue"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 4.5v15m7.5-7.5h-15"
            />
          </svg>
          <span>{t("addAnotherFishItem_DifferentFish")}</span>
        </button>

        {/* Option 3: No, continue */}
        <button
          type="button"
          onClick={handleNo}
          className="w-full flex flex-row items-center justify-center gap-3 button-base button-bg-grad-2"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="size-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
            />
          </svg>

          <span>{t("addAnotherFishItem_No")}</span>
        </button>
      </div>
    </div>
  );
}
